import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import { KycLayout } from "@/features/kyc/components/KycLayout";
import { InvalidSessionPage } from "@/features/kyc/components/InvalidSessionPage";
import LandingPage from "@/pages/landing/LandingPage";
import VerificationPage from "@/pages/verification/VerificationPage";

export default function KycApp() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/v" element={<KycLayout />}>
            <Route index element={<InvalidSessionPage />} />
            <Route path=":sessionId" element={<VerificationPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
